import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { ILocalizedResource } from 'src/common/interfaces/dtos/ILocalizedResource';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const getTouchpointLocalizedResource = async (
  applicationId: string,
  culture: string,
): Promise<ILocalizedResource> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/touchpoint/localized-resources',
    method: 'GET',
    params: {
      applicationId: applicationId,
      culture: culture,
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'get-touchpoint-locale' },
  };

  return emeraldRequest<ILocalizedResource>(emeraldRequestParams);
};
